<template>
  <div>
    <router-view/>
  </div>
</template>

<script>
export default {
  name: "app"
};
</script>

<style>
.v-toast__icon {
  display: none !important;
}
</style>
